enum MediaSizes {
  Small = '576px',
  Large = '992px',
  ExtraLarge = '1200px',
}

export { MediaSizes }
